import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/routing", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/routing/csv", params);
};

const upsert = data => {
  return restApi.post("/api/routing/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/routing/${ids}`);
};

const routingService = {
  getAll,
  getAllForCSV,
  upsert,
  remove,
};

export default routingService;